import _ from 'lodash';
import feathers from '@feathersjs/feathers';
import express from '@feathersjs/express';
import socketio from '@feathersjs/socketio';
import { log } from '@swiper/core';
import path from 'path';

import * as middleware from './middleware';
import authentication from './authentication';
import channels from '../channels';
import services from '../services';
import hooks from './hooks';
import plugins from './plugins';
import config from '~/config';

const clientpkg = require.resolve( '@swiper/client/package.json' );
const clientdir = path.dirname( clientpkg );
const staticdir = path.resolve( clientdir, 'dist' );

const app = express( feathers() )
  .configure( patchFeathers ) // must be first
  .configure( applyConfigs )
  .configure( express.rest() )
  .configure( middleware.express )
  .configure( socketio( middleware.socketio ) )
  .configure( authentication )
  .configure( middleware.feathers )
  .configure( services )
  .configure( channels );

app.use( historyFallbackHandler );
app.use( express.errorHandler( { logger : log } ) );

app.configure( hooks );

export default app;

function applyConfigs( instance ) {
  instance.config = config;
  _.each( config.data, ( val, key ) => instance.set( key, val ) );
  instance.set( 'staticdir', staticdir );
  instance.set( 'assetsdir', config.dir( 'assets' ) );
  plugins.fire( 'onInit', instance );
}

function patchFeathers( instance ) {
  const origService = instance.service;
  instance.service = function service( name ) {
    if ( ! name.startsWith( '/api' ) ) name = `/api/${name}`;
    return origService.call( this, name );
  };
}

function historyFallbackHandler( req, res, next ) {
  const canFallback = req.accepts( 'html' )
    && ( req.method === 'GET' || req.method === 'HEAD' );
  if ( ! canFallback ) return next();
  res.sendFile( 'index.html', {
    // maxAge, lastModified, headers,
    root      : staticdir,
    dotfiles  : 'ignore',
  }, err => { if ( err ) next(); } );
}
